const domain = process.env.REACT_APP_SHOPIFY_STORE_DOMAIN;
const token = process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN;
const version = process.env.REACT_APP_SHOPIFY_API_VERSION;

export async function shopifyFetch(query, variables = {}) {
  const response = await fetch(`https://${domain}/api/${version}/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": token,
    },
    body: JSON.stringify({ query, variables }),
  });

  const data = await response.json();

  if (data.errors) {
    throw new Error("Erro na Shopify");
  }

  return data.data;
}